'use client'

/* eslint-disable @typescript-eslint/no-explicit-any */

import { createContext, type ReactNode, useContext } from 'react'

export const labelDefaults = {
    help: {
        readMore: 'Read more',
        feedbacks: {
            title: 'Did you get the help you need?',
            textLogin: 'Log in to give feedback on this article.',
            login: 'Log in',
            yes: 'Yes',
            no: 'No',
            improveTitle: 'How can we improve this article?',
            improvePlaceholder:
                'Your feedback helps us fix typos, simplify confusing language, as well as spot potentially outdated instructions.',
            send: 'Send',
            thanks: 'Thank you for your feedback!',
            cancel: 'Back',
        },
        articleBoxes: {
            quickTip: 'Quick tip',
            note: 'Note',
            warning: 'Warning',
        },
    },
    platforms: {
        select: 'Select Platform:',
        web: 'Web',
        ios: 'iOS',
        ipados: 'iPadOS',
        android: 'Android',
        mac: 'macOS',
        'windows-legacy': 'Windows Legacy',
        'windows-10': 'Windows 10/11',
        linux: 'Linux',
    },
}

export type HelpCenterContextProps = {
    labels: typeof labelDefaults
    imageMaxWidth: number
    // biome-ignore lint/suspicious/noExplicitAny: tricky to type properly
    youTubeComponent?: any
}
export const HelpCenterContext = createContext({ labels: labelDefaults } as HelpCenterContextProps)

export type HelpCenterContextProviderProps = {
    children: ReactNode
    value: HelpCenterContextProps
}
export function HelpCenterContextProvider({ children, value }: HelpCenterContextProviderProps) {
    return <HelpCenterContext.Provider value={value}>{children}</HelpCenterContext.Provider>
}

export function useHelpCenterContext() {
    const ctx = useContext(HelpCenterContext)

    if (ctx === undefined) {
        throw new Error('useHelpCenterContext must be within HelpCentersContext')
    }

    return ctx
}
